// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMessagesSparkle } from '@ni/nimble-components/dist/esm/icons/messages-sparkle';
import { wrap } from '../utilities/react-wrapper';

export { type IconMessagesSparkle };
export const NimbleIconMessagesSparkle = wrap(IconMessagesSparkle);